// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "static/js/0f7f3857b284dac28a47.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"190900bf20c25b01c295","138":"15d492fbd3e18c26f2b8","139":"56e58ac6737eb7312016"}[chunkId] + ".chunk.js";
};